import { $can, $isRole } from '@/core/utils/VueAcl'

export default {
  sectionName: 'LeftNavigation_Dashboard',
  icon: 'navigation-dashboard',
  index: '1',
  isAllowed: () => $can('viewProjectItem') || $isRole('consent-admin'),
  routeName: 'ProjectOverview'
}



// WEBPACK FOOTER //
// ./src/common/components/navigation/navigation-section-items/dashboard.js